import { useDocumentTitle, useResetQueryState } from '@/hooks';
import { AlertRulesList } from '@/features/AlertRulesList/AlertRulesList';
import { EventFeed } from '@/features/EventFeed';

export default function AlertRulesPage() {
    useResetQueryState();
    useDocumentTitle('alertRules');

    return (
        <>
            <EventFeed context={{ type: 'alerts' }} />
            <AlertRulesList />
        </>
    );
}
